module.exports = __webpack_public_path__ + "media/images/icons/close_filter-e0fa8f7b39bf1a6adb5742f3b5d45d18.svg";